import { Component, Input } from '@angular/core';
import { InfoFormModalService } from 'src/app/services/info-form-modal.service';
import { IdType } from 'src/app/models/id-type.enum';
import { UnsubscriberComponent } from 'src/app/components/shared/unsubscriber.component';
import { ToastrService } from 'ngx-toastr';
import { TranslatePipe } from '@ngx-translate/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs/operators';

@Component({
    selector: 'app-info-form-modal',
    templateUrl: './info-form-modal.component.html',
    providers: [TranslatePipe],
    standalone: false
})
export class InfoFormModalComponent extends UnsubscriberComponent {
  @Input() public idType: IdType;
  @Input() public instance: string;
  public submitting: boolean;

  constructor(
    private infoModalService: InfoFormModalService,
    private toastrService: ToastrService,
    private translatePipe: TranslatePipe,
    private modal: NgbActiveModal
  ) {
    super();
  }

  public closeModal(reason: string): void {
    this.infoModalService.closeModal(reason, this.modal);
  }

  public onSubmit(message: string): void {
    NProgress.start();
    this.submitting = true;
    this.subscriptions.add(
      this.infoModalService
        .createNote(message, this.idType, this.instance)
        .pipe(finalize(() => (this.submitting = false)))
        .subscribe(
          () => {
            this.toastrService.success(
              this.translatePipe.transform('BO_ADD_NOTE_SUCCESS')
            );
            this.closeModal('');
          },
          () => {
            this.toastrService.error(
              this.translatePipe.transform('BO_ADD_NOTE_ERROR')
            );
            NProgress.done();
          }
        )
    );
  }
}
